import type { MisconceptionDefinition } from '../types'

export const hoekMisconceptions: MisconceptionDefinition[] = [
  {
    id: 'met.hoek-som-190',
    label: 'Denkt dat driehoeksom 190° is',
    module: 'Metriek',
    description:
      'Leerling denkt dat de hoeken van een driehoek samen 190° zijn in plaats van 180°.',
    typicalFamilies: ['MET-HOEK-BEREKENEN'],
  },
  {
    id: 'met.hoek-verschil-ipv-aftrekken',
    label: 'Trekt hoeken van elkaar af i.p.v. van 180°',
    module: 'Metriek',
    description:
      'Leerling trekt de twee bekende hoeken van elkaar af in plaats van beide van 180° af te trekken.',
    typicalFamilies: ['MET-HOEK-BEREKENEN'],
  },
  {
    id: 'met.hoek-optellen-ipv-aftrekken',
    label: 'Telt bekende hoeken op als antwoord',
    module: 'Metriek',
    description:
      'Leerling telt de twee bekende hoeken op en geeft die som als de derde hoek.',
    typicalFamilies: ['MET-HOEK-BEREKENEN'],
  },
  {
    id: 'met.gelijkbenig-gelijkzijdig-verward',
    label: 'Verwart gelijkbenig met gelijkzijdig (60°)',
    module: 'Metriek',
    description:
      'Leerling denkt dat alle hoeken in een gelijkbenige driehoek 60° zijn (verwart met gelijkzijdig).',
    typicalFamilies: ['MET-HOEK-BEREKENEN'],
  },
  {
    id: 'met.gelijkbenig-niet-delen',
    label: 'Vergeet door 2 te delen bij gelijkbenig',
    module: 'Metriek',
    description:
      'Leerling trekt de tophoek van 180° af maar vergeet het resultaat door 2 te delen voor de twee basishoeken.',
    typicalFamilies: ['MET-HOEK-BEREKENEN'],
  },
  {
    id: 'met.gelijkbenig-tophoek-gelijk',
    label: 'Denkt alle hoeken gelijk aan tophoek',
    module: 'Metriek',
    description:
      'Leerling denkt dat de basishoeken gelijk zijn aan de tophoek in een gelijkbenige driehoek.',
    typicalFamilies: ['MET-HOEK-BEREKENEN'],
  },
  {
    id: 'met.gestrekte-hoek-190',
    label: 'Denkt gestrekte hoek is 190°',
    module: 'Metriek',
    description:
      'Leerling denkt dat een gestrekte hoek (rechte lijn) 190° is in plaats van 180°.',
    typicalFamilies: ['MET-HOEK-BEREKENEN'],
  },
  {
    id: 'met.gestrekte-hoek-160',
    label: 'Denkt gestrekte hoek is 160°',
    module: 'Metriek',
    description:
      'Leerling denkt dat een gestrekte hoek 160° is in plaats van 180°.',
    typicalFamilies: ['MET-HOEK-BEREKENEN'],
  },
  {
    id: 'met.gestrekte-hoek-gelijk',
    label: 'Denkt hoeken op lijn altijd gelijk',
    module: 'Metriek',
    description:
      'Leerling denkt dat twee hoeken op een rechte lijn altijd even groot zijn.',
    typicalFamilies: ['MET-HOEK-BEREKENEN'],
  },
  {
    id: 'met.vierhoek-som-fout',
    label: 'Rekenfout bij optellen drie hoeken',
    module: 'Metriek',
    description:
      'Leerling maakt een rekenfout bij het optellen van de drie bekende hoeken in een vierhoek.',
    typicalFamilies: ['MET-HOEK-BEREKENEN'],
  },
  {
    id: 'met.vierhoek-aanname-90',
    label: 'Neemt aan dat vierde hoek 90° is',
    module: 'Metriek',
    description:
      'Leerling neemt aan dat de vierde hoek van een vierhoek 90° is zonder te rekenen.',
    typicalFamilies: ['MET-HOEK-BEREKENEN'],
  },
  {
    id: 'met.vierhoek-driehoek-verward',
    label: 'Gebruikt 180° i.p.v. 360° voor vierhoek',
    module: 'Metriek',
    description:
      'Leerling gebruikt de driehoeksom (180°) voor een vierhoek in plaats van 360°.',
    typicalFamilies: ['MET-HOEK-BEREKENEN'],
  },
  {
    id: 'met.hoek-type-verward',
    label: 'Hoeksoort verward',
    module: 'Metriek',
    description:
      'Leerling verwart scherpe, stompe, rechte of gestrekte hoeken (bijv. 55° als stomp bestempeld).',
    typicalFamilies: ['MET-HOEK-SOORTEN'],
  },
  {
    id: 'met.hoek-draai-verward',
    label: 'Draaihoek verward',
    module: 'Metriek',
    description:
      'Leerling verwart kwart/halve/hele draai met het verkeerde aantal graden (bijv. kwart draai = 180°).',
    typicalFamilies: ['MET-HOEK-SOORTEN', 'MET-HOEK-BEREKENEN'],
  },
  {
    id: 'met.driehoek-gelijkbenig-vs-gelijkzijdig',
    label: 'Gelijkbenig vs. gelijkzijdig verward',
    module: 'Metriek',
    description:
      'Leerling verwart gelijkbenig (2 gelijke zijden) met gelijkzijdig (3 gelijke zijden), of denkt dat 2 gelijke zijden volstaan voor gelijkzijdig.',
    typicalFamilies: ['MET-DRIEHOEK-SOORTEN'],
  },
  {
    id: 'met.driehoek-zijden-met-hoeken-verward',
    label: 'Zijden-classificatie verward met hoeken-classificatie',
    module: 'Metriek',
    description:
      'Leerling gebruikt zijden-eigenschappen (gelijkbenig/gelijkzijdig) wanneer hoeken-classificatie (scherp/recht/stomp) gevraagd is, of andersom.',
    typicalFamilies: ['MET-DRIEHOEK-SOORTEN'],
  },
  {
    id: 'met.driehoek-hoeken-met-zijden-verward',
    label: 'Hoeken-classificatie verward met zijden-classificatie',
    module: 'Metriek',
    description:
      'Leerling gebruikt hoeken-eigenschappen waar zijden-classificatie gevraagd is, of verwart de twee classificatie-assen bij driehoeken.',
    typicalFamilies: ['MET-DRIEHOEK-SOORTEN'],
  },
  {
    id: 'met.driehoek-tegengestelde-classificatie',
    label: 'Tegengestelde driehoek-classificatie',
    module: 'Metriek',
    description:
      'Leerling kiest de tegenovergestelde classificatie (bijv. stomp i.p.v. scherp) — duidt op oppervlakkige toepassing van regels zonder visuele controle.',
    typicalFamilies: ['MET-DRIEHOEK-SOORTEN'],
  },
  {
    id: 'met.driehoek-gelijke-zijden-gemist',
    label: 'Gelijke zijden over het hoofd gezien',
    module: 'Metriek',
    description:
      'Leerling herkent twee of drie gelijke zijden niet in de figuur en classificeert daardoor de driehoek als ongelijkzijdig.',
    typicalFamilies: ['MET-DRIEHOEK-SOORTEN'],
  },
  {
    id: 'met.driehoek-180graden-regel-niet-toegepast',
    label: '180°-regel niet toegepast',
    module: 'Metriek',
    description:
      'Leerling weet niet of past niet toe dat de som van de hoeken in een driehoek 180° is, en kan daardoor onmogelijke combinaties niet uitsluiten.',
    typicalFamilies: ['MET-DRIEHOEK-SOORTEN', 'MET-HOEK-BEREKENEN'],
  },
  {
    id: 'met.driehoek-onmogelijke-combinatie',
    label: 'Onmogelijke driehoek-combinatie gekozen',
    module: 'Metriek',
    description:
      'Leerling kiest een combinatie van zijden of hoeken die geen geldige driehoek vormt (bijv. hoekensom ≠ 180°, of driehoeksongelijkheid geschonden).',
    typicalFamilies: ['MET-DRIEHOEK-SOORTEN'],
  },
  {
    id: 'met.hoek-recht-vs-stomp',
    label: 'Rechte hoek verward met stompe hoek',
    module: 'Metriek',
    description:
      'Leerling beschouwt 90° als stomp of een stompe hoek als recht; de drempel bij precies 90° wordt verkeerd geplaatst.',
    typicalFamilies: ['MET-DRIEHOEK-SOORTEN', 'MET-HOEK-SOORTEN'],
  },
  {
    id: 'met.gelijkbenig-niet-delen-context',
    label: 'Vergeet door 2 te delen (context)',
    module: 'Metriek',
    description:
      'Leerling vergeet in een contextopgave de overgebleven hoek door 2 te delen om de twee gelijke basishoeken van een gelijkbenige driehoek te krijgen.',
    typicalFamilies: ['MET-HOEK-BEREKENEN'],
  },
  {
    id: 'met.gelijkbenig-delen-door-3',
    label: 'Deelt tophoek door 3 i.p.v. rest door 2',
    module: 'Metriek',
    description:
      'Leerling deelt de tophoek door 3 (alsof alle hoeken gelijk zijn) i.p.v. 180° − tophoek door 2 te delen voor de basishoeken.',
    typicalFamilies: ['MET-HOEK-BEREKENEN'],
  },
  {
    id: 'met.gelijkbenig-delen-door-6',
    label: 'Deelt tophoek door 6',
    module: 'Metriek',
    description:
      'Leerling deelt de tophoek door 6 — willekeurige delerfout zonder didactische logica, vaak door verkeerd onthouden regel.',
    typicalFamilies: ['MET-HOEK-BEREKENEN'],
  },
  {
    id: 'met.hoek-aanvullend-verwarring',
    label: 'Aanvullende hoek getekend i.p.v. gevraagde',
    module: 'Metriek',
    description:
      'Leerling tekent de aanvullende hoek (180° − x) in plaats van de gevraagde hoek.',
    typicalFamilies: ['MET-HOEK-TEKENEN'],
  },
  {
    id: 'met.hoek-helft-verwarring',
    label: 'Helft van de hoek getekend',
    module: 'Metriek',
    description:
      'Leerling tekent een hoek die de helft is van het gevraagde aantal graden.',
    typicalFamilies: ['MET-HOEK-TEKENEN'],
  },
  {
    id: 'met.hoek-rechte-hoek-default',
    label: 'Rechte hoek als default getekend',
    module: 'Metriek',
    description:
      'Leerling tekent automatisch een rechte hoek (90°) ongeacht het gevraagde aantal graden.',
    typicalFamilies: ['MET-HOEK-TEKENEN'],
  },
  {
    id: 'met.hoek-schaal-verkeerd',
    label: 'Verkeerde schaal op geodriehoek gekozen',
    module: 'Metriek',
    description:
      'Leerling negeert het verschil tussen binnen- en buitenschaal op de geodriehoek of denkt dat de schaal niet uitmaakt.',
    typicalFamilies: ['MET-HOEK-TEKENEN', 'MET-HOEK-METEN'],
  },
  {
    id: 'met.hoek-kleinste-altijd',
    label: 'Altijd kleinste getal gekozen',
    module: 'Metriek',
    description:
      'Leerling kiest standaard het kleinste getal op de geodriehoek en negeert of het een scherpe of stompe hoek is.',
    typicalFamilies: ['MET-HOEK-TEKENEN', 'MET-HOEK-METEN'],
  },
  {
    id: 'met.hoek-combineren-fout',
    label: 'Hoeken onterecht gecombineerd',
    module: 'Metriek',
    description:
      'Leerling denkt dat losse hoeken bij elkaar opgeteld of gecombineerd moeten worden waar dat niet hoort.',
    typicalFamilies: ['MET-HOEK-TEKENEN'],
  },
  {
    id: 'met.hoek-tekenen-stappen-fout',
    label: 'Verkeerde volgorde bij hoek tekenen',
    module: 'Metriek',
    description:
      'Leerling volgt de tekenstappen voor een hoek in de verkeerde volgorde (bijv. eerst de boog, dan het beginpunt).',
    typicalFamilies: ['MET-HOEK-TEKENEN'],
  },
  {
    id: 'met.hoek-binnenrand-default',
    label: 'Binnenrand altijd gebruikt',
    module: 'Metriek',
    description:
      'Leerling denkt dat altijd de binnenrand van de geodriehoek gebruikt moet worden, ongeacht hoe het beginpunt ligt.',
    typicalFamilies: ['MET-HOEK-TEKENEN'],
  },
  {
    id: 'met.hoek-90-grens-onduidelijk',
    label: '90°-grens onduidelijk bij categoriseren',
    module: 'Metriek',
    description:
      'Leerling plaatst hoeken nabij 90° in de verkeerde categorie omdat de grens tussen scherp/recht/stomp onduidelijk is.',
    typicalFamilies: ['MET-HOEK-SOORTEN-CATEGORIZE', 'MET-HOEK-SOORTEN'],
  },
  {
    id: 'met.hoek-scherp-stomp-omgewisseld',
    label: 'Scherp en stomp omgewisseld',
    module: 'Metriek',
    description:
      'Leerling wisselt de begrippen scherp en stomp om bij het categoriseren van hoeken.',
    typicalFamilies: ['MET-HOEK-SOORTEN-CATEGORIZE', 'MET-HOEK-SOORTEN'],
  },
  {
    id: 'met.hoek-beschrijving-naar-type',
    label: 'Beschrijving niet aan juiste hoeksoort gekoppeld',
    module: 'Metriek',
    description:
      'Leerling kan een beschrijving (bijv. "een kwart draai") niet correct koppelen aan de juiste hoeksoort.',
    typicalFamilies: ['MET-HOEK-SOORTEN-CATEGORIZE'],
  },
  {
    id: 'met.hoek-gestrekte-niet-herkend',
    label: 'Gestrekte hoek niet herkend',
    module: 'Metriek',
    description:
      'Leerling herkent een gestrekte hoek (180°) niet als hoeksoort.',
    typicalFamilies: ['MET-HOEK-SOORTEN-CATEGORIZE', 'MET-HOEK-SOORTEN'],
  },
  {
    id: 'met.hoek-klok-3uur-niet-recht',
    label: 'Klok om 3 uur niet als rechte hoek herkend',
    module: 'Metriek',
    description:
      'Leerling herkent de hoek tussen de wijzers van een klok om 3 uur niet als een rechte hoek (90°).',
    typicalFamilies: ['MET-HOEK-SOORTEN-CATEGORIZE'],
  },
]
